import React from 'react'
import * as actions from '../../App/actions'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router'
import { CircleSpinner } from 'common/spinners'
import appStyles from '../../App/appStyles.scss'
import styles from './EditPage.scss'
import { Button } from 'common/Button'

export class EditPage extends React.Component {
  constructor (props) {
    super(props)
    const { title, subtitle } = this.props.reportsPage
    this.state = { title, subtitle }
  }

  componentWillReceiveProps (nextProps) {
    const { title, subtitle } = nextProps.reportsPage
    this.setState({ title, subtitle })
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSubmit = () => {
    const id = this.props.reportsPage.id
    const { updateReportsPage, router } = this.props
    updateReportsPage(id, this.state)
    router.push(`/reports_pages/${id}`) // fixme this url doesn't match the user profile url
  }

  render () {
    const { id } = this.props.reportsPage

    if (!id) {
      return (
        <CircleSpinner size={50} />
      )
    }

    return (
      <div className={styles.EditPage}>
        <h1 className={appStyles.pageTitle}>Customize your page</h1>
        <form onSubmit={this.onSubmit}>
          <div>
            <label>Title </label>
            <input type='text' name='title' value={this.state.title || ''} onChange={this.onChange} />
          </div>
          <div>
            <label>Subtitle </label>
            <input type='text' name='subtitle' value={this.state.subtitle || ''} onChange={this.onChange} />
          </div>
          <div className={styles.buttons}>
            <Link to={`/reports_pages/${id}`}><Button type='default' className={styles.withMargin}>Cancel</Button></Link>
            <Button type='default' onClick={this.onSubmit}>Save</Button>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  reportsPage: state.reportsPage
})

const mapDispatchToProps = (dispatch) => ({
  loadReportsPage: id => dispatch(actions.loadReportsPage(id)),
  updateReportsPage: (id, attrs) => dispatch(actions.updateReportsPage(id, attrs))
})

const EditPageWithRouter = withRouter(EditPage)

export const EditPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPageWithRouter)
